<template>
  <main>
    <v-container id="maincontainer" fluid fill-height>
      <v-row align="center" justify="center">
        <v-col class="px-15">
          <v-col cols="12">
            <v-img
              :src="require('../assets/BQLD Logo.png')"
              class="my-1"
              contain
              height="75"
            />
          </v-col>
          <span>
            Version:
            {{ this.versionData[0].versionNo }}
          </span>
          <p>
            Released:
            {{ this.versionData[0].releaseDate }}
          </p>
          <v-form ref="Login" class="text" v-model="loginValid" lazy-validation>
            <v-text-field
              outlined
              label="Username"
              prepend-icon="mdi-account-circle"
              v-model="username"
              required
              :rules="[(v) => !!v || 'Username is required']"
            />
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              outlined
              label="Password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              v-model="password"
              required
              :rules="PasswordRules"
            />
            <p>{{ error }}</p>
          </v-form>

          <v-row class="my-4" align="center" justify="center">
            <v-btn
              color="oug"
              min-width="250"
              light
              outlined
              @click="validate"
              elevation="24"
              :loading="loading"
              loading-text="Loading ..."
            >
              Login
            </v-btn>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <v-row class="mt-4" align="center" justify="center">
            <router-link class="mr-2" to="/Register">
              Register
            </router-link>
            /
            <router-link class="ml-2" to="/Reset">
              Forgot Password
            </router-link>
          </v-row>
          <v-row class="mb-1" align="center" justify="center">
            <Zendesk />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<script>
import versionControl from "../data/versionControl.json";
import Zendesk from "./Zendesk";
export default {
  name: "Login",
  components: {
    Zendesk,
  },
  prop: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      assocName: "",
      versionData: versionControl,
      loginValid: true,
      showPassword: false,
      username: null,
      password: null,
      PasswordRules: [(value) => !!value || "Password is Required!"],
      contact_id: 0,
      association: 0,
      error: null,
      loading: false,
    };
  },
  created() {
    if (localStorage.getItem("sLastUser")) {
      this.username = localStorage.getItem("sLastUser");
      this.password = localStorage.getItem("sUserUID");
    }
  },
  methods: {
    Login() {
      this.loading = true;
      let credentials = { username: this.username, password: this.password };
      this.$store
        .dispatch("login", credentials)
        .then(() => {
          // a) load documents
          this.$store.dispatch("getDocuments", JSON.parse(localStorage.getItem("Coach")).contact)
          // Load Modules
          this.$store.dispatch("getModules", JSON.parse(localStorage.getItem("Coach")).contact)
          // Load Connections
          this.$store.dispatch("getTeams", JSON.parse(localStorage.getItem("Coach")).contact)
          // Step 1: Get current teams from local store (Array)
          this.currentTeams = JSON.parse(
            localStorage.getItem("Coach")
          ).current_teams;
          // Step 2: Loop through array using foreach (array.find) Looking for code_id == 423
          if (this.currentTeams.some((team) => team.Code_id === 423)) {
            // Load the details of the user to the Support WebChat 
            this.$router.push("/Home");
          } else {
            this.$router.push("/");
            this.$toast.error(
              "You do not have the correct access to the BQ Coaches App. Please contact coachdev@basketballqld.net.au for assistance.",
              {
                timeout: 6000,
              }
            );
          }
        })
        // If does find record, push to home, if not push to login
        .catch(() => {
          this.$toast.error(
              "You have entered an incorrect username/password combination. If problems persist, please try resetting your credentials by pressing 'Forgot Password' below, or by contacting support@ownurgoal.zendesk.com",
              {
                timeout: 6000,
              }
            );
          this.loading = false;
        });
    },
    validate() {
      if (this.$refs.Login.validate()) {
        this.Login();
      }
    },
  },

  computed: {},
};
</script>

<style scoped>
.text {
  font-size: 18px;
  color: blue;
}
</style>
